"use strict";

const provideLogo = require("./provide-logo/provide-logo.view");
const customCoverCards = require("./custom-cover-cards/custom-cover-cards.view");

module.exports = {
	provideLogo,
	customCoverCards,
};
